<template>
    <div>
        <div class="row">
            <div class="col s12 m8 l10 xl10">
                <div class="row">
                    <div class="input-field col s12">
                        <i class="material-icons prefix ">search</i>
                        <input
                            id="search"
                            type="text"
                            class="validate"
                            v-model="filterTerm"
                        />
                        <label for="search">Pesquisar</label>
                    </div>
                </div>
            </div>
            <div class="col s12 m4 l2 xl2">
                <a
                    :disabled="!edit || enviado == true || !disabled_button"
                    href="/projetos/create"
                    title="Submeter nova ação"
                    class="cyan waves-effect waves-light btn-small left"
                >
                    <i class="material-icons ">add</i></a
                >
            </div>
        </div>

        <div class="row">
            <div class="col s12 m12 l12 xl12">
                <!-- <pre>{{ [sortProperty, sortDirection, sortPropertyId] | json }}</pre> -->

                <table>
                    <thead>
                        <tr>
                            <th class="hide-on-med-and-down">
                                #
                                <a
                                    class="left"
                                    href="#"
                                    @click="toggleOrder($event, 'id')"
                                >
                                    <i
                                        class="material-icons"
                                        v-bind:class="{
                                            'red-text': sortPropertyId
                                        }"
                                        >sort</i
                                    >
                                </a>
                            </th>
                            <th>
                                Título da Ação
                                <a
                                    class="left"
                                    href="#"
                                    @click="toggleOrder($event, 'titulo')"
                                >
                                    <i
                                        class="material-icons"
                                        v-bind:class="{
                                            'red-text': sortPropertyTitulo
                                        }"
                                        >sort</i
                                    >
                                </a>
                            </th>
                            <th v-if="edit">
                                Editar
                            </th>
                            <th v-if="edit && !enviado">
                                Excluir
                            </th>
                            <th>
                                Ver
                            </th>
                            <th v-if="parecer_pert && algumNaoPert()">
                                Parecer Pert.
                            </th>
                            <th v-if="ini_recurso_pert && algumNaoPert()">
                                Rec. Pert.
                            </th>
                            <th v-if="parecer_rec_pert && algumNaoPert()">
                                Parecer Rec. Pert.
                            </th>
                            <th v-if="resultado">
                                Resultado
                            </th>
                            <th v-if="ini_recurso_aval">
                                Rec. Aval.
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(projeto, index) in filteredInscricaos"
                            :key="!projeto.id ? projeto.id : index"
                        >
                            <td>{{ index + 1 }}</td>
                            <td>{{ projeto.titulo }}</td>
                            <td v-if="edit">
                                <a
                                    :href="'/projetos/' + projeto.id + '/edit'"
                                    class="waves-effect waves-light btn-small"
                                >
                                    <i class="material-icons">edit</i>
                                </a>
                            </td>
                            <td v-if="edit && !enviado">
                                <a
                                    @click="
                                        btnDeleteProject($event, projeto.id)
                                    "
                                    class="waves-effect waves-light btn-small"
                                >
                                    <i class="material-icons">delete</i>
                                </a>
                            </td>
                            <td>
                                <a
                                    :href="'/projetos/' + projeto.id + '/edit/'"
                                    class="waves-effect blue-light btn-small"
                                >
                                    <i class="material-icons">search</i>
                                </a>
                            </td>
                            <td v-if="parecer_pert && algumNaoPert()">
                                <a
                                    v-if="projeto.parecer"
                                    :href="'/pertinencia/pdf/' + projeto.id"
                                    class="waves-effect blue-light btn-small"
                                    ><i class="material-icons"
                                        >remove_red_eye</i
                                    ></a
                                >
                            </td>
                            <td v-if="ini_recurso_pert && algumNaoPert()">
                                <a
                                    v-if="
                                        (fim_recurso_pert &&
                                            projeto.pertinente == false &&
                                            !projeto.recursos.length) ||
                                            recPertinencia(projeto.recursos)
                                    "
                                    :href="
                                        '/recursos/pertinencia/' + projeto.id
                                    "
                                    class="waves-effect blue-light btn-small"
                                    ><i class="material-icons">replay</i></a
                                >
                            </td>
                            <td v-if="parecer_rec_pert && algumNaoPert()">
                                <a
                                    v-if="recPertinencia(projeto.recursos)"
                                    :href="
                                        '/recursos/pdf/pertinencia/' +
                                            projeto.id
                                    "
                                    class="waves-effect blue-light btn-small"
                                    ><i class="material-icons"
                                        >remove_red_eye</i
                                    ></a
                                >
                            </td>
                            <td v-if="resultado">
								<a :href="'/projetos/resultado/' + projeto.id"
                                    class="waves-effect blue-light btn-small"
                                    ><i class="material-icons">remove_red_eye</i></a>
							</td>
                            <td v-if="ini_recurso_aval">
                                <a
                                    v-if="
                                        (fim_recurso_aval &&
                                            projeto.pertinente == true &&
                                            !recAval(projeto.recursos)) ||
                                            recAval(projeto.recursos)
                                    "
                                    :href="'/recursos/nova_avaliacao/' + projeto.id"
                                    class="waves-effect blue-light btn-small"
                                    ><i class="material-icons">replay</i></a
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="input-field col s12 m12 l6 xl6">
                <center>
                    <a
                        v-if="listaInscricaos.length"
                        href="/projetos/ver/false"
                        class="btn indigo"
                        ><i class="material-icons left">remove_red_eye</i
                        >Visualizar resumo</a
                    >
                </center>
            </div>
            <div class="input-field col s12 m12 l6 xl6">
                <center>
                    <a
                        v-if="edit && !enviado && listaInscricaos.length"
                        href="/projetos/ver/true"
                        class="btn"
                        ><i class="material-icons left">done_all</i>Enviar em
                        definitivo</a
                    >
                    <a
                        v-if="enviado"
                        href="/projetos/comprovante"
                        class="btn indigo"
                        ><i class="material-icons left">remove_red_eye</i
                        >Visualizar comprovante</a
                    >
                </center>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VueProjetos",
    props: [
        "projetos",
        "parecer_pert",
        "ini_recurso_pert",
        "fim_recurso_pert",
        "parecer_rec_pert",
        "edit",
        "enviado",
        "resultado",
        "ini_recurso_aval",
        "fim_recurso_aval",
        "disabled_button"
    ],
    data() {
        return {
            listaInscricaos: JSON.parse(this.projetos),
            sortProperty: "id",
            sortDirection: "asc",
            filterTerm: "",
            sortPropertyId: true,
            sortPropertyNome: false,
            sortPropertyTitulo: false
        };
    },
    computed: {
        listInscricaosOp: function() {
            this.listaInscricaos = _.orderBy(
                this.listaInscricaos,
                this.sortProperty,
                this.sortDirection
            );
        },
        filteredInscricaos: function() {
            var self = this;
            return _.orderBy(
                self.listaInscricaos.filter(function(projeto) {
                    var searchRegex = new RegExp(self.filterTerm, "i");
                    return (
                        searchRegex.test(projeto.titulo) ||
                        searchRegex.test(projeto.pdf)
                    );
                }),
                this.sortProperty,
                this.sortDirection
            );
        }
    },
    methods: {
        btnDeleteProject(event, id) {
			if (confirm('Tem certeza de que deseja remover a ação da inscrição? Essa ação não poderá ser desfeita!')) {
				event.preventDefault();
				$.ajax({
					headers: {
						"X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
					},
					method: "DELETE",
					url: "/projetos/" + id,
					success: resp => {
						setTimeout(() => {
							window.location.href = "/projetos/";
						}, 100);
						showMsg(resp, 200);
					}
				});
			}
        },

        toggleOrder(ev, field) {
            ev.preventDefault();
            if (this.sortProperty == field) {
                if (this.sortDirection == "asc") this.sortDirection = "desc";
                else this.sortDirection = "asc";
            } else {
                this.iconsColor(this.sortProperty, false);
                this.iconsColor(field, true);
                this.sortProperty = field;
                this.sortDirection = "asc";
            }
        },
        iconsColor(field, value) {
            switch (field) {
                case "id":
                    this.sortPropertyId = value;
                    break;
                case "titulo":
                    this.sortPropertyTitulo = value;
                    break;
                case "nome":
                    this.sortPropertyNome = value;
                    break;
                default:
            }
        },
        btnSubmeterOnClick() {
            //e.preventDefault();
            let formData = new FormData();
            $.ajax({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                url: "/curriculos/",
                method: "post",
                processData: false,
                contentType: false,
                data: formData,
                success: response => {
                    showMsg(response, 200);
                }
            });
        },
        recPertinencia(recursos) {
            let i = recursos.length;
            while (--i >= 0) if (recursos[i].etapa == 3) return true;
            return false;
        },
        recAval(recursos) {
            let i = recursos.length;
            while (--i >= 0) if (recursos[i].etapa == 4) return true;
            return false;
        },
        algumNaoPert() {
            let projetos = this.listaInscricaos;
            let i = projetos.length;
            while (--i >= 0) if (!projetos[i].pertinente) return true;
            return !this.ini_recurso_aval;
        }
    }
};
</script>
